import React from 'react'
import { Box, Modal, Fade, Backdrop, Typography, Grid } from '@mui/material';
import { style } from '../../common/modalStyle'
import { closeModal } from './suppliersList'
import AddNewSupplier from './addNewSupplier'


export default function OpenModal(state) {
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        setOpen(state.isOpen);
    }, [state.isOpen])


    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={closeModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Box sx={{ backgroundColor: '#1e1f21', color: '#fff', p: 2 }}>
                            <Typography variant="h6" component="h2">
                                Edytuj dostawcę
                            </Typography>
                        </Box>
                        <Box sx={{ p: 4 }}>
                            <Grid
                                spacing={2}
                                container
                            >
                                <AddNewSupplier modalData={state.modalData} type={'edit'} />
                            </Grid>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </div>
    )
}
